<template>
  <div class="text-header">
    <template v-if="title.includes('<h1>') || title.includes('<p>')">
      <div
        v-html="title"
        class="text-header__title title-l-1"
        data-animate="preloader-reveal"
      />
    </template>
    <template v-else>
      <h1 class="text-header__title title-l-1" data-animate="preloader-reveal">
        {{ title }}
      </h1>
    </template>
    <div
      v-if="subtitle && subtitle !== ''"
      v-html="subtitle"
      data-animate="preloader-opacity"
      class="text-header__subtitle text-m-1 m-top-l-1"
    />
    <div
      v-if="intro && intro !== ''"
      data-animate="preloader-opacity"
      class="text-heder__intro m-top-l-1 title-base"
      v-html="intro"
    />
  </div>
</template>

<script>
export default {
  name: 'PagesCommonTextHeader',
}
</script>

<script setup>
const props = defineProps({
  title: String,
  intro: String,
  subtitle: String,
})
</script>

<style lang="scss">
@import './style.scss';
</style>
